// Envia eventos do funil de conversao do cardapio publico para o backend.
// Dedup por (tenant, ip, janela 4h, tipo) acontece no servidor.
import { obterOrigemAnuncio } from "@/lib/origemAnuncio";
import { obterSmsRef } from "@/lib/smsRef";

import { getTenantSlug } from "./tenantScope";

const API = "/api";

export async function trackFunnel(eventType, extra = {}) {
  // Meta Pixel da loja (por tenant): espelha o evento do funil no fbq, se o
  // pixel estiver injetado no cardápio (window.fbq existe). No-op sem pixel —
  // nunca quebra e não afeta lojas sem Meta Pixel. (visit=PageView é disparado
  // na injeção; completed=Purchase é disparado na conclusão do pedido.)
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      const map = { view: "ViewContent", cart: "AddToCart", revision: "InitiateCheckout" };
      const fbEvent = map[eventType];
      if (fbEvent) {
        const params = {};
        if (extra && extra.product_id != null) {
          params.content_ids = [extra.product_id];
          params.content_type = "product";
        }
        if (extra && extra.value != null) { params.value = extra.value; params.currency = "BRL"; }
        window.fbq("track", fbEvent, params);
      }
    }
  } catch { /* tracking nunca quebra a UX */ }

  try {
    const tenantSlug = getTenantSlug();
    // Funil por campanha (Anúncios Meta): o código do link (?c=) e o id da campanha
    // guardados no clique vão junto de cada degrau, quando existem.
    const campanha_codigo = obterSmsRef() || undefined;
    const meta_campaign_id = obterOrigemAnuncio()?.campaign_id || undefined;
    const body = JSON.stringify({
      tenant_slug: tenantSlug,
      event_type: eventType,
      campanha_codigo,
      meta_campaign_id,
      ...extra,
    });
    await fetch(`${API}/public/cardapio-funnel/event`, {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body,
    });
  } catch {
    // Tracking nunca pode quebrar a UX
  }
}

/**
 * Purchase do Meta Pixel na conclusão do pedido do cardápio.
 *
 * `eventID` = código do pedido: é o que permite, quando a compra também for
 * enviada pelo servidor (Conversions API, fase 6 do plano de Anúncios Meta),
 * a Meta descartar a duplicata em vez de contar duas vezes. `content_ids` =
 * produtos do pedido, para a Meta saber O QUE vendeu. Sem pixel é no-op.
 */
export function trackPurchase({ codigo, id, items, value }) {
  try {
    if (typeof window === "undefined" || typeof window.fbq !== "function") return;
    const contentIds = (items || [])
      .map((it) => it?.product_id ?? it?.id)
      .filter((pid) => pid != null)
      .map(String);
    const params = { value: Number(value) || 0, currency: "BRL" };
    if (contentIds.length) {
      params.content_ids = contentIds;
      params.content_type = "product";
      params.num_items = (items || []).reduce((n, it) => n + (Number(it?.quantity ?? it?.quantidade) || 1), 0);
    }
    const eventID = codigo || id;
    window.fbq("track", "Purchase", params, eventID ? { eventID: String(eventID) } : undefined);
  } catch { /* tracking nunca quebra a UX */ }
}
